import AT from 'country-flag-icons/react/3x2/AT';
import BE from 'country-flag-icons/react/3x2/BE';
import CH from 'country-flag-icons/react/3x2/CH';
import CZ from 'country-flag-icons/react/3x2/CZ';
import DE from 'country-flag-icons/react/3x2/DE';
import DK from 'country-flag-icons/react/3x2/DK';
import ES from 'country-flag-icons/react/3x2/ES';
import EU from 'country-flag-icons/react/3x2/EU';
import FI from 'country-flag-icons/react/3x2/FI';
import FR from 'country-flag-icons/react/3x2/FR';
import GB from 'country-flag-icons/react/3x2/GB';
import GR from 'country-flag-icons/react/3x2/GR';
import HU from 'country-flag-icons/react/3x2/HU';
import IE from 'country-flag-icons/react/3x2/IE';
import IT from 'country-flag-icons/react/3x2/IT';
import NL from 'country-flag-icons/react/3x2/NL';
import NO from 'country-flag-icons/react/3x2/NO';
import PL from 'country-flag-icons/react/3x2/PL';
import PT from 'country-flag-icons/react/3x2/PT';
import RO from 'country-flag-icons/react/3x2/RO';
import SE from 'country-flag-icons/react/3x2/SE';
import US from 'country-flag-icons/react/3x2/US';

const FLAG_COMPONENTS: Record<string, React.ComponentType<{ className?: string }>> = {
  AT,
  BE,
  CH,
  CZ,
  DE,
  DK,
  ES,
  EU,
  FI,
  FR,
  GB,
  GR,
  HU,
  IE,
  IT,
  NL,
  NO,
  PL,
  PT,
  RO,
  SE,
  UK: GB, // UK maps to GB
  US,
};

interface FlagIconProps {
  countryCode: string;
  className?: string;
}

export const FlagIcon = ({ countryCode, className = 'w-5 h-auto' }: FlagIconProps) => {
  const code = countryCode?.toUpperCase();
  const FlagComponent = FLAG_COMPONENTS[code];

  if (!FlagComponent) {
    // Fallback: show the country code as text
    return <span className={className}>{countryCode}</span>;
  }

  return <FlagComponent className={className} />;
};
